export function clamp(v: number, min: number, max: number): number {
  return Math.min(Math.max(v, min), max);
}

export function approxEqual(v1: number, v2: number, epsilon: number): boolean {
  return Math.abs(v1 - v2) < epsilon;
}
